import React, { useState } from 'react';

const SearchFeedback = ({ filters, query }) => {
  const [selected, setSelected] = useState(null);
  const [sent, setSent] = useState(false);

  const sendFeedback = async (score) => {
    try {
      const token = localStorage.getItem('token');

      setSelected(score);

      await fetch(`${process.env.REACT_APP_API_URL}/search-feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          query,
          score,
          filters,
          timestamp: new Date().toISOString(),
        }),
      });

      setSent(true);
    } catch (err) {
      console.error('Ошибка отправки оценки поиска:', err);
    }
  };

  const containerStyle = {
    margin: '16px auto',
    display: 'flex',
    justifyContent: 'center',
  };

  const wrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px',
    color: '#4f5f78',
  };

  const buttonStyle = (activeColor, isActive) => ({
    border: 'none',
    background: isActive ? '#eef5ff' : 'transparent',
    cursor: sent ? 'default' : 'pointer',
    fontSize: '20px',
    borderRadius: '50%',
    padding: '6px',
    transition: 'all 0.2s ease',
    color: isActive ? activeColor : '#5f6368',
  });

  if (sent) {
    return (
      <div style={containerStyle}>
        <div style={{ fontSize: '13px', color: '#6b7a90' }}>
          Спасибо за отзыв 👍
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={wrapperStyle}>
        <span>Полезны результаты?</span>

        <button
          onClick={() => !sent && sendFeedback(1)}
          style={buttonStyle('#1f9d55', selected === 1)}
          onMouseEnter={(e) => {
            if (!sent && selected !== 1) {
              e.currentTarget.style.background = '#f3fbf6';
              e.currentTarget.style.transform = 'scale(1.1)';
            }
          }}
          onMouseLeave={(e) => {
            if (!sent && selected !== 1) {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.transform = 'scale(1)';
            }
          }}
        >
          👍
        </button>

        <button
          onClick={() => !sent && sendFeedback(0)}
          style={buttonStyle('#d14343', selected === 0)}
          onMouseEnter={(e) => {
            if (!sent && selected !== 0) {
              e.currentTarget.style.background = '#fff7f7';
              e.currentTarget.style.transform = 'scale(1.1)';
            }
          }}
          onMouseLeave={(e) => {
            if (!sent && selected !== 0) {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.transform = 'scale(1)';
            }
          }}
        >
          👎
        </button>
      </div>
    </div>
  );
};

export default SearchFeedback;